import { Container } from "@mui/material";
import { Outlet } from "react-router";

export default function PublicLayout() {
  return (
    <Container
      maxWidth="sm"
      sx={{
        height: "100dvh",
        py: { xs: 0, sm: 3 },
      }}
    >
      <Outlet />
    </Container>
  );
}
